import { isEmptyArray } from '../objects/isEmpty';
import { upperCaseValue } from './upperCaseValue';

export function equalsIgnoreCase(valueA: string | undefined, valueB: string | undefined): boolean {
	const upperA = upperCaseValue(valueA);
	const upperB = upperCaseValue(valueB);
	return upperA === upperB;
}

export function containsIgnoreCase(list: string[] | undefined, value: string | undefined): boolean {
	if (isEmptyArray(list)) {
		return false;
	}

	return list.some((listValue) => equalsIgnoreCase(listValue, value));
}

export function containsAnyIgnoreCase(list: string[] | undefined, values: string[] | undefined): boolean {
	if (isEmptyArray(list)) {
		return false;
	}

	if (isEmptyArray(values)) {
		return false;
	}

	return values.some((value) => containsIgnoreCase(list, value));
}

export function onlyContainsIgnoreCase(list: string[] | undefined, value: string | undefined): boolean {
	if (isEmptyArray(list)) {
		return false;
	}

	return list.every((listValue) => equalsIgnoreCase(listValue, value));
}
